export default class Favourites {
	constructor(container) {
		 this.favouritesElement = container;
		 this.favouritesElement.disabled = false;
		 this.popupElement = document.querySelector('.popup-favourites');

		 // match current favourite list
		 let cookieValue = document.cookie.match(new RegExp('(^| )' + ( customData?.cookieFavourites ?? null ) + '=([^;]+)'));
		 cookieValue = null === cookieValue ? '' : cookieValue[2];
		 cookieValue = decodeURIComponent(cookieValue);
		 let favourites = cookieValue == '' ? [] : cookieValue.split(',');
		 let currentPageId = 0;
		 document.body.classList.forEach((className) => {
			if ( className.indexOf('postid-') > -1 ) {
				currentPageId = className.replace('postid-','');
			}
		 })

		 // check if page already listed
		 if ( favourites.indexOf( currentPageId ) > -1 ) {
			this.favouritesElement.classList.add('active');
		 }

		 this.favouritesElement.addEventListener('click', () => {
			  if (this.favouritesElement.classList.contains('active')) {
					// add popup
					this.changePopupVisibility(true);
					this.favouritesElement.classList.remove('active');
			  } else {
					// add popup
		 			this.changePopupVisibility(false);
					this.favouritesElement.classList.add('active');
			  }
			  updateCookieWishlist(favourites,currentPageId);
		 });
	}

	addDocumentClickListener() {
		 this.documentClickListener = (event) => {
			  if (!this.popupElement.contains(event.target) && !this.favouritesElement.contains(event.target)) {
					this.popupElement.classList.remove('open');
					this.removeDocumentClickListener();
			  }
		 };
		 document.addEventListener('click', this.documentClickListener);
	}

	removeDocumentClickListener() {
		 document.removeEventListener('click', this.documentClickListener);
	}

	changePopupVisibility(remove) {
		 // match login cookie
		 let match = document.cookie.match(new RegExp('(^| )' + ( customData?.cookieContactId ?? null ) + '=([^;]+)'));
		 match = null === match ? '' : match[2];
		 let isLoggedIn = match ? true : false;

		 this.popupElement.querySelectorAll('.popup-favourites__main').forEach((el) => {
			el.style.display = 'none';
	 	 })

		 if (remove) {
			this.popupElement.querySelectorAll('.popup-favourites__main').forEach((el) => {
				if ( el.classList.contains('popup-favourites__remove') ) {
					el.style.display = 'flex';
				} else {
					el.style.display = 'none';
				}
			})
		 } else {
			this.popupElement.querySelectorAll('.popup-favourites__main').forEach((el) => {
				if ( String(el.dataset.logged_in) == String(isLoggedIn) ) {
					el.style.display = 'flex';
				} else {
					el.style.display = 'none';
				}
			})
		}

		this.popupElement.classList.add('open');
		this.addDocumentClickListener();
	}
}

export function updateCookieWishlist(favourites,addOrRemoveIds) {
	console.log( favourites );
	console.log( addOrRemoveIds );
	console.log( customData?.cookieFavourites );


	var expiryDate = new Date();
	expiryDate.setMonth(expiryDate.getMonth() + 1);
	let newValue = '';

	if ( 'string' == typeof addOrRemoveIds ) {
		addOrRemoveIds = [ addOrRemoveIds ];
	}

	for ( var i in addOrRemoveIds ) {
		let id = addOrRemoveIds[i];
		let index = favourites.indexOf(id);
		if ( index > -1 ) {
			// remove value from Array
			favourites.splice(index,1);
		} else {
			// add value to Array
			favourites.push(id);
		}
	}

	newValue = favourites.length > 0 ? favourites.join(',') : '';

	if ( newValue == '' ) {
		expiryDate = new Date();
		expiryDate.setMonth(expiryDate.getMonth() - 1);
	}

	console.log('Updating wishlist...');
	document.cookie = customData?.cookieFavourites + '=' + newValue + '; expires=' + expiryDate + '; path=/';
}
